import React from 'react'
import { Trans } from 'react-i18next'
import { FiShield } from 'react-icons/fi'
import Flex from 'typescript-styled-flex'
import {
  Label,
  Link,
  MenuElement,
} from '../../../../../components/Template/Sidebar'

function Password() {
  return (
    <MenuElement alignCenter={true}>
      <Link to={'/password'}>
        <Flex alignCenter={true}>
          <b>
            <FiShield size={16} />
          </b>
          <Label primary={true}>
            <Trans i18nKey={'menu_password'}>Zmiana hasła</Trans>
          </Label>
        </Flex>
      </Link>
    </MenuElement>
  )
}

export default Password
